var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"contribute-card echarts-box",attrs:{"shadow":"never"}},[_c('h4',[_vm._v("用户贡献对比")]),(_vm.userContribute)?_c('div',{attrs:{"id":"contribute"}}):_c('NoData',{attrs:{"errTitle":"暂无数据","setHeight":"400px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }